export default __webpack_public_path__ + "static/media/tyre-image-3.c4221cf4.png";